module.exports = __webpack_public_path__ + "static/media/chicken.22148802.png";